import { ReactNode, FC, createContext, useState, useMemo } from 'react';
type ISCOArchetypeContextType = {
    isISCOPopupShown?: boolean;
    setIsISCOPopupShown?: React.Dispatch<React.SetStateAction<boolean>>;
    selectedParentISCO?: any;
    setSelectedParentISCO?: React.Dispatch<React.SetStateAction<any>>;
    selectedChildISCO?: any;
    setSelectedChildISCO?: React.Dispatch<React.SetStateAction<any>>;
    showISCODetails?: boolean;
    setShowISCODetails?: React.Dispatch<React.SetStateAction<boolean>>;
    showSkillsDetails?: boolean;
    setShowSkillsDetails?: React.Dispatch<React.SetStateAction<boolean>>;
    isLaborForcastPopupShown?: boolean;
    setIsLaborForcastPopupShown?: React.Dispatch<React.SetStateAction<boolean>>;
};

const ISCOArchetypeContext = createContext<ISCOArchetypeContextType>({});

type ISCOArchetypeProps = {
    children: ReactNode;
};

const ISCOArchetype: FC<ISCOArchetypeProps> = ({ children }) => {
    const [isISCOPopupShown, setIsISCOPopupShown] = useState<boolean>(false); // State to track the selected item
    const [selectedParentISCO, setSelectedParentISCO] = useState<any>(null); // State to track the selected item
    const [selectedChildISCO, setSelectedChildISCO] = useState<any>(null); // State to track the selected item
    const [showISCODetails, setShowISCODetails] = useState<boolean>(false); // State to track the selected item
    const [showSkillsDetails, setShowSkillsDetails] = useState<boolean>(false); // State to track the selected item
    const [isLaborForcastPopupShown, setIsLaborForcastPopupShown] = useState<boolean>(false); // State to track the selected item

    const ISCOArchetypeProviderValue = useMemo(
        () => ({
            isISCOPopupShown, setIsISCOPopupShown,
            selectedParentISCO, setSelectedParentISCO,
            selectedChildISCO, setSelectedChildISCO,
            showISCODetails, setShowISCODetails,
            showSkillsDetails, setShowSkillsDetails,
            isLaborForcastPopupShown, setIsLaborForcastPopupShown
        }),
        [
            isISCOPopupShown, setIsISCOPopupShown,
            selectedParentISCO, setSelectedParentISCO,
            selectedChildISCO, setSelectedChildISCO,
            showISCODetails, setShowISCODetails,
            showSkillsDetails, setShowSkillsDetails,
            isLaborForcastPopupShown, setIsLaborForcastPopupShown
        ],
    );

    return (
        <ISCOArchetypeContext.Provider value={ISCOArchetypeProviderValue}>
            {children}
        </ISCOArchetypeContext.Provider>
    );
};

export { ISCOArchetype, ISCOArchetypeContext };
